// Formats UI option labels without mutating built-in prototypes during the Vue 3 migration.

function decodeEntities(value) {
    const string = value == null ? '' : String(value);

    if (typeof document === 'undefined') {
        return string;
    }

    const textarea = document.createElement('textarea');
    textarea.innerHTML = string;
    return textarea.value;
}

function splitCamelCase(value) {
    return value
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, string => string.toUpperCase());
}

function titleCase(value) {
    return value.replace(/\w\S*/g, string => {
        return string.charAt(0).toUpperCase() + string.substr(1).toLowerCase();
    });
}

export default function formatLabel(value, emptyOverride = '') {
    const label = titleCase(splitCamelCase(decodeEntities(value)));

    return label || emptyOverride;
}
